module.exports = __webpack_public_path__ + "img/login-mobile3.a56d4005.jpg";